<template>
  <div
    class="carousel-slide"
    :style="{ padding: `0 ${padding}px` }"
    v-bind="additionalProperties"
  >
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'Slide',
    props: {
      customAttributes: {
        type: Object,
        required: false,
        default: null
      }
    },
    data() {
      return {
        padding: this.$parent.slidePadding
      };
    },
    computed: {
      additionalProperties() {
        if (!this.customAttributes) {
          return {};
        }

        return {
          ...this.$attrs,
          ...this.customAttributes
        };
      }
    },
    mounted () {
      this.$parent.$on('pageChange', this.emitPause);
    },
    methods: {
      emitPause() {
        this.$emit('pauseVideo');
      }
    }
  };
</script>
